import {
  Box,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
  useMediaQuery,
  useToast
} from '@chakra-ui/react';
import { AxiosError } from 'axios';
import exportFromJSON from 'export-from-json';
import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

import { Button } from '../../../../components/buttons/Button';
import { Spinner } from '../../../../components/widgets/Spinner';
import VisualizationContext from '../../../../contexts/VisualizationContext';
import { api } from '../../../../services/api';
import { apiSensedia } from '../../../../services/api-sensedia';
import { LayoutGestaoLeads } from './components/LayoutGestaoLeads';
import { ModalDistribuicao } from './components/ModalDistribuicao';
import { ModalRedistribuicao } from './components/ModalRedistribuicao';
import { OrganizationMethodCard } from './components/OrganizationMethodCard';
import { SummaryCard } from './components/SummaryCard';
import TableLeads from './components/TableLeads';

let apiGestaoLeads = api;

if (process.env.NODE_ENV !== 'development') {
  apiGestaoLeads = apiSensedia;
}

function GestaoLeads() {
  const { visualizationState, setVisualizationState } =
    useContext(VisualizationContext);

  const [tableLeads, setTableLeads] = useState<any>([]);
  const [cardValue, setCardValue] = useState({
    contadores: {
      concluidos: 0,
      distribuir: 0,
      em_negociacao: 0,
      novas_oportunidades: 0,
      novo_contato: 0,
      redistribuir: 0,
      total: 0
    },
    perfis: [],
    configuracoes: {
      transbordo: false,
      tempo_transbordo: 10,
      distribuicao_automatica: false,
      tipo_distribuicao_automatica: '1/1'
    }
  });

  const toast = useToast();

  const [vendedores, setVendedores] = useState([
    {
      id: '',
      codigo_produtor: '',
      tipo: '',
      data_criacao: {
        _seconds: 1685127548,
        _nanoseconds: 394000000
      },
      telefone_2: '',
      telefone_1: '',
      id_atualizacao: '',
      nome: '',
      email: '',
      status: '',
      id_gestor: '',
      data_atualizacao: {
        _seconds: 1685131438,
        _nanoseconds: 932000000
      },
      leads_usuario: [],
      quantidade_leads_recebidos: 0,
      quantidade_leads_atendidos: 0,
      quantidade_leads_naoAtendidos: 0,
      quantidade_leads_leadsHot: 0,
      taxa_sucesso: '30%'
    }
  ]);

  const [isMobile] = useMediaQuery('(max-width: 920px)');

  const [loading, setLoading] = useState(true);

  const {
    onClose: onCloseRedistribuir,
    isOpen: isOpenRedistribuir,
    onOpen: onOpenRedistribuir
  } = useDisclosure();

  const {
    onClose: onCloseDistribuir,
    isOpen: isOpenDistribuir,
    onOpen: onOpenDistribuir
  } = useDisclosure();

  const fetchData = async () => {
    try {
      setLoading(true);

      const { data } = await apiSensedia.get(
        `/oportunidades-sulamerica/painel-leads/gestao`,
        {
          timeout: 0
        }
      );

      setVendedores([...data.perfis]);
      setCardValue({ ...data });
      setLoading(false);
    } catch (error: any) {
      const errorObj = error?.toJSON();
      toast({
        position: 'top',
        description: (
          <Box>
            <Text>
              {' '}
              Ocorreu um erro. Esvazie o cache do navegador, aguarde alguns
              minutos e tente fazer login novamente, se persistir, por favor
              entrar em contato.
            </Text>
            <Text>
              {errorObj?.status && (
                <>
                  <br />
                  <b>Detalhes:</b>
                  <br />
                </>
              )}
              {(errorObj?.status || error?.response?.data?.statusCode) && (
                <>{errorObj.status ?? error?.response.data.statusCode}</>
              )}
              {errorObj?.status &&
                (error?.response?.data?.message || errorObj?.message) &&
                ' - '}
              {(error?.response?.data?.message || errorObj?.message) && (
                <>{error.response.data.message ?? errorObj.message}</>
              )}
            </Text>
          </Box>
        ),
        duration: 15000,
        isClosable: true,
        status: 'error'
      });

      console.error('Erro ao buscar dados:', error);
      setLoading(false);
    }
  };

  const handleOpenRedistribuicao = () => {
    onOpenRedistribuir();
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const handleOpenDistribuicao = () => {
    onOpenDistribuir();
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const reloadFlag = localStorage.getItem('reloadFlag');

  useEffect(() => {
    if (reloadFlag) {
      setVisualizationState('gestao');
      fetchData();
    }
  }, [reloadFlag]);

  useEffect(() => {
    const reloadFlag = localStorage.getItem('reloadFlag');
    if (!reloadFlag) {
      localStorage.setItem('reloadFlag', 'true');
      window.location.reload();
    } else {
      localStorage.removeItem('reloadFlag');
    }
  }, []);

  const leadsSummaryCards = [
    {
      title: 'Visão geral',
      count: cardValue.contadores.total.toString(),
      isBeta: false,
      button: (
        <div className="tw-w-full tw-flex tw-justify-center tw-px-[16px]">
          <Link
            to={'/corretor/leads/listagem'}
            className="tw-bg-[#FF5000] tw-text-center tw-text-white tw-w-full tw-px-[16px] tw-mt-2 tw-py-[0.4rem] tw-rounded-full"
          >
            Acessar
          </Link>
        </div>
      )
    }
  ];

  const leadsOrganizationMethods = [
    {
      title: 'Distribuir novos Leads',
      description: 'Distribua os novos Leads para a sua equipe.',
      count: cardValue.contadores.distribuir.toString() || '0',
      button: (
        <div className="tw-w-full md:tw-max-w-[65%] tw-px-[16px]">
          <Button
            className={`tw-bg-[#001e64] tw-w-full disabled:tw-bg-[#828282]`}
            onClick={handleOpenDistribuicao}
            disabled={cardValue.contadores?.distribuir <= 0}
          >
            Distribuir
          </Button>
        </div>
      )
    },
    {
      title: 'Redistribuir Leads',
      description: 'Envie Leads de um vendedor para outro da sua equipe.',
      count: cardValue.contadores.redistribuir.toString() || '0',
      button: (
        <div className="tw-w-full md:tw-max-w-[65%] tw-px-[16px]">
          <Button
            className={`tw-bg-[#001e64] tw-w-full`}
            onClick={handleOpenRedistribuicao}
          >
            Redistribuir
          </Button>
        </div>
      )
    }
  ];

  return (
    <LayoutGestaoLeads>
      <div className="tw-flex tw-justify-between tw-flex-col tw-gap-[1.88rem] tw-px-[16px] md:tw-px-0">
        <div className="tw-flex tw-gap-6 tw-flex-wrap md:tw-justify-start md:tw-items-start tw-justify-center tw-items-center">
          {leadsSummaryCards.map((summaryCard) => (
            <SummaryCard
              key={summaryCard.title}
              isBeta={summaryCard?.isBeta}
              title={summaryCard.title}
              count={summaryCard.count}
              button={summaryCard.button}
            />
          ))}
        </div>
        <p className="tw-text-2xl tw-font-bold">
          Escolha o seu modelo de organização de Leads:
        </p>
        <div className="tw-flex tw-gap-6 tw-flex-wrap md:tw-flex-nowrap md:tw-justify-start md:tw-items-start tw-justify-center tw-items-center">
          {leadsOrganizationMethods.map((leadsOrganizationMethod) => (
            <OrganizationMethodCard
              key={leadsOrganizationMethod.title}
              title={leadsOrganizationMethod.title}
              description={leadsOrganizationMethod.description}
              count={leadsOrganizationMethod.count}
              button={leadsOrganizationMethod.button}
            />
          ))}
        </div>

        <div
          id="leads"
          className="tw-bg-white tw-flex tw-justify-center tw-items-center tw-flex-col tw-shadow-[0px_0px_5px_rgba(50,50,50,0.25)] tw-rounded-2xl"
        >
          {tableLeads.length > 0 && !loading ? (
            <TableLeads rowsPerPage={5} header="Leads" data={tableLeads} />
          ) : null}
        </div>
        {isOpenRedistribuir && (
          <ModalRedistribuicao
            apiGestaoLeads={apiGestaoLeads}
            onClose={onCloseRedistribuir}
            data={vendedores}
            disponiveis={cardValue.contadores.redistribuir}
          />
        )}
        {isOpenDistribuir && (
          <ModalDistribuicao
            apiGestaoLeads={apiGestaoLeads}
            onClose={onCloseDistribuir}
            data={vendedores}
            disponiveis={cardValue.contadores.distribuir}
          />
        )}
      </div>
    </LayoutGestaoLeads>
  );
}

export default GestaoLeads;
